<div id="invitations" class="invitations">
  <div class="visible-info title">
    <div class="name bold">
      <p>{{ 'CONTACTS.INVITE_CONTACT' | translate }}</p>

    </div>
    @if (showSignIn) {
    <div class="icon-wrapper">
      <div class="row-icon signin-icon"></div>
    </div>
    } @else {
    <div></div>
    }

    <div class="icon-wrapper">
      <div class="row-icon add-contact-icon hvr-grow" (click)="openContactLinkInvitationDialog()"></div>
    </div>

    <div class="icon-wrapper">
      <div class="row-icon add-tech-icon hvr-grow" (click)="openSendLinkInvitationDialog()"></div>
    </div>
  </div>
</div>
